import { decode } from "html-entities";
import { useCallback, useMemo } from "react";
import { defaultCurrency, useCalculatorContext, } from "../../Contexts/CalculatorContext";
const formatPrice = (priceInCents, target, currencyData) => {
    const currency = currencyData.find((currency) => currency.alias == target) ??
        defaultCurrency;
    let amount = (priceInCents / 100).toFixed(2);
    if (amount.slice(-3) === ".00") {
        amount = amount.substring(0, amount.length - 3);
    }
    return decode(currency.symbol, { level: "html5" }) + amount;
};
const getCentsPricingByThresholdAndCurrency = (participants, currency, pricing) => {
    // Loop through pricing and include ALL that apply
    const pricingTiers = pricing.filter((value) => {
        if (value.currencyAlias.toUpperCase() !== currency) {
            return false;
        }
        return true;
    });
    // For each pricing tier until the last one, get the maximum price
    let participantCumulativePrice = 0;
    let baseFee = 0;
    let enabledTiers = [];
    pricingTiers.map((value) => {
        baseFee = value.base;
        let numParticipantsInTier = 0;
        if (value.minValue == 1) {
            // Lowest tier they can be in - exclude prepaid participants
            let nonPrepaidParticipants = Math.min(value.maxValue - 25, participants - 25);
            numParticipantsInTier = Math.max(0, nonPrepaidParticipants);
        }
        else if (value.maxValue >= participants || value.maxValue == 0) {
            // This is the highest tier they are in, so only add the remainder
            numParticipantsInTier = participants - value.minValue + 1;
        }
        else {
            // Tier is NOT the max tier they can be in
            numParticipantsInTier = value.maxValue - value.minValue + 1;
        }
        value.numParticipantsInTier = numParticipantsInTier;
        enabledTiers.push(value);
        if (value.minValue > participants) {
            return;
        }
        participantCumulativePrice += numParticipantsInTier * value.price;
    });
    return {
        base: +baseFee,
        participantCumulativePrice: +participantCumulativePrice,
        enabledTiers: enabledTiers
    };
};
const useCalculator = () => {
    const { currency, participants, setParticipants, currencies, pricing } = useCalculatorContext();
    let enabledTiersPricing = [];
    const price = useMemo(() => {
        const { base, participantCumulativePrice, enabledTiers } = getCentsPricingByThresholdAndCurrency(participants, currency, pricing);
        const priceInCents = base + participantCumulativePrice;
        enabledTiersPricing = enabledTiers;
        return formatPrice(priceInCents, currency, currencies);
    }, [currency, participants, pricing]);
    const updateParticipants = useCallback((event) => {
        const next = parseInt(event.target.value);
        const formatted = isNaN(next) ? 0 : next;
        if (formatted > 1000) {
            return;
        }
        setParticipants(formatted);
    }, [setParticipants]);
    return {
        price,
        participants,
        updateParticipants,
        currencies,
        currency,
        enabledTiersPricing,
    };
};
export { useCalculator };
